import React, { useState, useEffect } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';

const categories = [
  '个人成长',
  '职业',
  '健康',
  '财务',
  '学习',
  '创意',
  '人际关系',
  '其他'
];

function GoalModal({ goal, template, onSave, onClose }) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '个人成长',
    targetDate: '',
    milestones: [{ title: '', targetDate: '' }]
  });

  useEffect(() => {
    if (goal) {
      setFormData({
        title: goal.title,
        description: goal.description,
        category: goal.category,
        targetDate: goal.targetDate || '',
        milestones: goal.milestones.map(m => ({
          id: m.id,
          title: m.title,
          targetDate: m.targetDate || '',
          completed: m.completed
        }))
      });
    } else if (template) {
      setFormData({
        title: template.title,
        description: template.description,
        category: template.category,
        targetDate: '',
        milestones: template.milestones.map(m => ({
          title: m.title,
          targetDate: ''
        }))
      });
    }
  }, [goal, template]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleMilestoneChange = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      milestones: prev.milestones.map((m, i) =>
        i === index ? { ...m, [field]: value } : m
      )
    }));
  };

  const addMilestone = () => {
    setFormData(prev => ({
      ...prev,
      milestones: [...prev.milestones, { title: '', targetDate: '' }]
    }));
  };

  const removeMilestone = (index) => {
    if (formData.milestones.length > 1) {
      setFormData(prev => ({
        ...prev,
        milestones: prev.milestones.filter((_, i) => i !== index)
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.title.trim() && formData.milestones.some(m => m.title.trim())) {
      onSave({
        ...formData,
        milestones: formData.milestones.filter(m => m.title.trim())
      });
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal animate-in" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            {goal ? '编辑目标' : '创建新目标'}
          </h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">目标名称</label>
              <input
                type="text"
                name="title"
                className="form-input"
                placeholder="例如：学习 Python 编程"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">目标描述</label>
              <textarea
                name="description"
                className="form-textarea"
                placeholder="描述你想要达成的具体目标..."
                value={formData.description}
                onChange={handleChange}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">分类</label>
                <select
                  name="category"
                  className="form-select"
                  value={formData.category}
                  onChange={handleChange}
                >
                  {categories.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">目标日期</label>
                <input
                  type="date"
                  name="targetDate"
                  className="form-input"
                  value={formData.targetDate}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">里程碑</label>
              <div className="milestone-inputs">
                {formData.milestones.map((milestone, index) => (
                  <div key={index} className="milestone-input-row">
                    <input
                      type="text"
                      className="form-input"
                      placeholder={`里程碑 ${index + 1}`}
                      value={milestone.title}
                      onChange={(e) => handleMilestoneChange(index, 'title', e.target.value)}
                    />
                    <input
                      type="date"
                      className="form-input"
                      value={milestone.targetDate}
                      onChange={(e) => handleMilestoneChange(index, 'targetDate', e.target.value)}
                    />
                    <button
                      type="button"
                      className="remove-milestone"
                      onClick={() => removeMilestone(index)}
                      disabled={formData.milestones.length === 1}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                ))}
                <div className="add-milestone" onClick={addMilestone}>
                  <Plus size={18} />
                  添加里程碑
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              {goal ? '保存更改' : '创建目标'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GoalModal;
